"use client";

export default function ViuGoMatchHeader() {
    return (
        <div className="kbv-shadow-soft-indigo-slate kbv-bg-header-indigo-slate sticky top-0 z-[2] flex w-full items-stretch overflow-hidden rounded-lg text-center text-[13px] leading-none text-white [&>div]:flex [&>div]:items-center [&>div]:justify-center [&>div]:border-t-0 [&>div]:border-b-0">
            <div className="w-[4%] shrink-0 rounded-tl-lg rounded-bl-lg" />

            <div className="w-[26%] font-normal">
                <div className="w-full pl-2.5 text-left">
                    <div>Trận Đấu</div>
                </div>
            </div>

            <div className="flex w-[35%] flex-col items-center justify-center">
                <div className="w-full border-t-0 py-[5px] text-center">Cả Trận</div>
            </div>

            <div className="flex w-[35%] flex-col items-center justify-center">
                <div className="w-full border-t-0 py-[5px] text-center">Hiệp 1</div>
            </div>
        </div>
    );
}
